import {useEffect, useState} from "react";
import {useGetCatgeory, useGetSectors} from "../../../hooks/useCategory";
import {useMe} from "../../../hooks/useGetUser";
import Loader from "../shared/Loader";
import SubCategoryDrop from "./SubCategory";
import {useUpdateTechnician} from "../../../hooks/useUpdateUser";
import useUserSectors from "../../../hooks/useUsersSectors";
import {buildImageUrl} from "../../../utils/imageUrlBuilder";
import {showToastModal} from "../shared/ToastModalSwal";

const ModifProfileExpertise = () => {
  const [selectedCat, setSelectedCat] = useState([]);
  const [subCatIds, setSubCatIds] = useState(new Set([]));
  const [selectedSector, setSelectedSector] = useState([]);
  const [sectorCategories, setSectorCategories] = useState([]);
  const {onAddSubCatgeory} = useUpdateTechnician();
  const {data, isLoading} = useMe();
  const {sectors, sectorsList} = useUserSectors();
  const {data: categories, isLoading: isLoadingCategory} = useGetCatgeory();
  useEffect(() => {
    setSelectedSector([...sectors]);
    sectors.forEach((el) => {
      const eleCategories = el?.Categories;
      setSectorCategories((prev) => [...prev, ...eleCategories]);
    });
    const subCategories = data?.Technician?.SubCategories;
    if (!!subCategories?.length && !!categories?.length) {
      subCategories.map((ele) => {
        setSubCatIds((prev) => prev.add(ele.id));
        let categoryObject = categories.find(
          (category) => category.id === ele.fatherId,
        );
        if (categoryObject)
          setSelectedCat((prev) => {
            let set = new Set([...prev, categoryObject]);
            return Array.from(set.values());
          });
      });
    }
  }, [data, categories, sectors]);
  if (isLoading || isLoadingCategory) {
    return <Loader />;
  }

  const handelUpdate = () => {
    if (!Array.from(subCatIds.values()).length) {
      showToastModal({
        success: false,
        title: "Complétez votre sélection",
        message: (
          <div className="font-normal">
            Après avoir choisi un secteur, sélectionnez{" "}
            <span className="font-semibold">les spécialités</span> et{" "}
            <span className="font-semibold">sous-spécialités </span>
            pour afficher les annonces qui vous correspondent.
          </div>
        ),
        buttonTitle: "Compléter",
      });
    } else {
      onAddSubCatgeory(Array.from(subCatIds.values()));
    }
  };
  const handleSelectSector = (e) => {
    let sector = sectorsList.find(
      (ele) => Number(ele.id) === Number(e.target.value),
    );
    if (sector) {
      setSelectedSector((prev) => {
        let set = new Set([...prev, sector]);
        return Array.from(set.values());
      });
      setSectorCategories((prev) => [...prev, ...sector?.Categories]);
    }
  };
  const handleSelect = (e) => {
    let categoryObject = categories.find((ele) => ele.id == e.target.value);

    if (categoryObject)
      setSelectedCat((prev) => {
        let set = new Set([...prev, categoryObject]);
        return Array.from(set.values());
      });
  };

  const handleDeleteSector = (ele) => {
    setSelectedCat((prev) => [...prev.filter((el) => el.fatherId !== ele.id)]);
    setSectorCategories((prev) => [
      ...prev.filter((el) => el.fatherId !== ele.id),
    ]);
    setSelectedSector((prev) => [...prev.filter((el) => el.id !== ele.id)]);
  };

  return (
    <div className="w-full flex flex-col justify-start p-6 items-start h-full gap-4  ">
      <h6 className="font-semibold text-xl">Mes compétences :</h6>
      <select
        className="form-control xl:w-2/3 custom-select-arrow "
        onChange={handleSelectSector}
      >
        <option value="" disabled selected hidden>
          Choisir mes compétences
        </option>
        {sectorsList?.map((sector) => (
          <option value={sector.id}>{sector.title}</option>
        ))}
      </select>
      <div className="flex justify-start items-center flex-wrap w-full gap-2">
        {!!selectedSector.length &&
          selectedSector.map((ele) => (
            <div className=" bg-[#F1F2F7] gap-2  font-bold text-sm  rounded-lg px-3 py-2 flex justify-center items-center text-[#19295C] ">
              <img src={buildImageUrl(ele.imagePath)} alt="" className="w-6" />
              {ele.title}{" "}
              <i
                className="fi fi-rr-cross-small flex justify-center items-center cursor-pointer"
                onClick={() => {
                  handleDeleteSector(ele);
                }}
              ></i>
            </div>
          ))}
      </div>

      {!!selectedSector.length && (
        <>
          <h6 className="font-semibold text-xl">Mes spécialités :</h6>
          <select
            className="form-control xl:w-2/3 custom-select-arrow "
            onChange={handleSelect}
          >
            <option value="" disabled selected hidden>
              Choisir mes spécialités
            </option>
            {sectorCategories?.map((category) => (
              <option value={category.id}>{category.title}</option>
            ))}
          </select>
          <div className="flex justify-start items-center flex-wrap gap-2">
            {!!selectedCat.length &&
              selectedCat.map((ele) => (
                <div className=" bg-gradient-to-r from-[#0022AA1A] to-[#1A64B91A] gap-2  font-bold text-sm  rounded-3xl px-4 py-2 flex justify-center items-center text-[#1A64B9] ">
                  {ele.title}{" "}
                  <i
                    className="fi fi-rr-cross-small flex justify-center items-center cursor-pointer"
                    onClick={() => {
                      setSelectedCat((prev) => [
                        ...prev.filter((el) => el.id !== ele.id),
                      ]);
                    }}
                  ></i>
                </div>
              ))}
          </div>
          <h6 className="font-semibold text-xl">Mes sous-spécialités :</h6>
          {!!selectedCat.length && (
            <div className="flex flex-wrap justify-start items-start gap-y-4 w-full">
              {selectedCat.map((category) => (
                <div className="w-full sm:w-1/2 xl:w-1/3 px-2">
                  <SubCategoryDrop
                    category={category}
                    subCatIds={Array.from(subCatIds.values())}
                    setSubCatIds={setSubCatIds}
                  />
                </div>
              ))}
            </div>
          )}
        </>
      )}
      <div className="flex justify-center md:justify-end items-center w-full gap-4 mt-2">
        <button
          type="button"
          onClick={handelUpdate}
          className="btn !min-w-[250px] flex justify-center !rounded-lg items-center bg-gradient-to-r from-[#0022AA] to-[#1A64B9] text-white "
        >
          Enregistrer
        </button>
      </div>
    </div>
  );
};

export default ModifProfileExpertise;
